// eslint-disable-next-line no-unused-vars
import React from 'react';
import { string, bool, object, func } from 'prop-types';
import {
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from '@carbon/react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { uniqueId } from 'lodash';

import { NWTextInput, NWCheckbox, NWButton } from 'Components/shared';

const StyledComposedModal = styled(ComposedModal)`
  z-index: 9001;
`;

const StyledFormContainer = styled(Form)`
  padding: 0;

  .wrapper {
    padding: 1rem;
  }

  .cds--checkbox-wrapper {
    padding-top: 5px;
  }

  .description {
    padding: 0 !important;
  }
`;

const StyledModalBody = styled(ModalBody)`
  background-color: ${ props => props.theme.colors.white };
  color: ${ props => props.theme.colors.darkGray };
  margin-bottom: 0;
  padding: 0 !important;
  font-size: 0.875rem;

  .cds--form-item {
    margin-bottom: 10px !important;
  }

  .cds--text-input {
    border: 1px solid ${ props => props.theme.products.colors.border };
    border-radius: 0;
    padding: 0 9px;
  }

  .cds--modal-footer {
    justify-content: center;
  }
`;

const fields = {
  name: 'name',
  isDefault: 'isDefault',
};

const EditWishlistModal = ({
  open,
  onClose,
  onSubmit,
  loading,
  className,
  title,
  validators,
  register,
  rhfErrors,
  setValue,
  isDefaultValue,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const sharedProps = fieldName => ({
    id: uniqueId(fieldName),
    name: fieldName,
    invalid: !!rhfErrors[fieldName]?.message.length,
    invalidText: rhfErrors[fieldName]?.message,
    ...register(fieldName, { ...validators[fieldName] }),
  });

  return (
    <StyledComposedModal
      open={ open }
      onClose={ onClose }
      size="sm"
      theme={ theme }
      danger={ !!Object.keys(rhfErrors).length }
      className={ className || 'EditWishlistModal' }
      selectorPrimaryFocus=".cds--modal-content"
    >
      <ModalHeader>
        <h4>{ title || t('wishlist.updateListTitle') }</h4>
      </ModalHeader>
      <StyledModalBody theme={ theme }>
        <StyledFormContainer
          // success={ status }
          // error={ status === false }
          onSubmit={ onSubmit }
        >
          <div className="wrapper">
            <NWTextInput
              data-modal-primary-focus
              className="name"
              disabled={ loading }
              light
              required
              labelText={ t('wishlist.listName') }
              placeholder={ t('wishlist.placeholder') }
              { ...sharedProps(fields.name) }
            />
            <NWCheckbox
              id={ uniqueId(fields.isDefault) }
              name={ fields.isDefault }
              disabled={ loading }
              labelText={ t('wishlist.isDefault') }
              checked={ isDefaultValue }
              onChange={ checked => {
                setValue(fields.isDefault, checked, { shouldDirty: true });
              } }
            />
            <p
              className="description"
              dangerouslySetInnerHTML={{ __html: t('wishlists.favorite') }}
            />
          </div>
          <ModalFooter>
            <NWButton
              className="red submit"
              type="submit"
              loading={ loading }
              disabled={ loading }
              // onClick={ formRef?.current?.submit }
              kind="primary"
            >
              { t('common.agree') }
            </NWButton>
            <NWButton
              kind="ghost"
              className="red"
              onClick={ onClose }
              disabled={ loading }
              tabIndex={ -1 }
            >
              { t('common.cancel') }
            </NWButton>
          </ModalFooter>
        </StyledFormContainer>
      </StyledModalBody>
    </StyledComposedModal>
  );
};

EditWishlistModal.propTypes = {
  open: bool,
  loading: bool,
  onClose: func,
  onFocus: func,
  onSubmit: func,
  className: string,
  title: string,
  validators: object,
  register: func,
  rhfErrors: object,
  setValue: func,
  isDefaultValue: bool,
};

export default EditWishlistModal;
